module.exports = "/img/story-1.eb8c9b69.png";